/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { ClosedEnum } from "../../types/enums.js";

/**
 * Comparison operator
 */
export const Operator = {
  Eq: "eq",
  NotEq: "not_eq",
  Contains: "contains",
  Exists: "exists",
  NotExists: "not_exists",
  In: "in",
} as const;
/**
 * Comparison operator
 */
export type Operator = ClosedEnum<typeof Operator>;

/**
 * A single filter condition for a log search query.
 */
export type LogFilter = {
  /**
   * Comparison operator
   */
  operator?: Operator | undefined;
  /**
   * Attribute path. Use @ prefix for custom attributes (e.g. '@user.region'), or bare path for system attributes (e.g. 'http.route').
   */
  path: string;
  /**
   * Values to compare against. Pass one value for single-value operators (eq, not_eq, contains) and multiple for 'in'. Ignored for 'exists' and 'not_exists'.
   */
  values?: Array<string> | undefined;
};

/** @internal */
export const Operator$outboundSchema: z.ZodMiniEnum<typeof Operator> = z.enum(
  Operator,
);

/** @internal */
export type LogFilter$Outbound = {
  operator: string;
  path: string;
  values?: Array<string> | undefined;
};

/** @internal */
export const LogFilter$outboundSchema: z.ZodMiniType<
  LogFilter$Outbound,
  LogFilter
> = z.object({
  operator: z._default(Operator$outboundSchema, "eq"),
  path: z.string(),
  values: z.optional(z.array(z.string())),
});

export function logFilterToJSON(logFilter: LogFilter): string {
  return JSON.stringify(LogFilter$outboundSchema.parse(logFilter));
}
